export default __webpack_public_path__ + "static/turtle-56674c4100668275b9ce68df8a56537f.png";